import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Tooltip} from '@stubhub/bamboo';

const DEFAULT_TOOLTIP_OFFSET_VALUE = 12;
const RIGHT_TOOLTIP_OFFSET = [0, DEFAULT_TOOLTIP_OFFSET_VALUE];
const DEFAULT_TOOLTIP_OFFSET = [-1 * DEFAULT_TOOLTIP_OFFSET_VALUE, DEFAULT_TOOLTIP_OFFSET_VALUE];

const selectOffset = ({placement}) => {
  if (placement === 'right') {
    return RIGHT_TOOLTIP_OFFSET;
  }

  return DEFAULT_TOOLTIP_OFFSET;
};

const IconWithTooltip = ({
  tooltipId,
  tooltipText,
  children,
  className = '',
  placement = 'top-start',
  fallbackPlacements = ['top-start', 'right', 'bottom-start'],
}) => {
  const [open, setOpen] = useState(false);
  const openTooltip = () => setOpen(true);
  const closeTooltip = () => setOpen(false);

  return (
    <Tooltip
      id={tooltipId}
      tooltipText={tooltipText}
      isOpen={open}
      placement={placement}
      fallbackPlacements={fallbackPlacements}
      offset={selectOffset}
      className={className}
    >
      <span data-testid={`${tooltipId}-testid`} onMouseEnter={openTooltip} onMouseLeave={closeTooltip}>
        {children}
      </span>
    </Tooltip>
  );
};

IconWithTooltip.propTypes = {
  tooltipId: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node,
  placement: PropTypes.string,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
  fallbackPlacements: PropTypes.arrayOf(PropTypes.string),
};

export default IconWithTooltip;
